import { productMap } from 'srcAlias/client/enums/productMap';
import {
  EQUITY_INVESTMENT_ACCOUNT_CATEGORY,
  STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY,
  BONDS_ACCOUNT_CATEGORY,
} from 'srcAlias/client/enums/productCategory';
import {
  EQUITY_INVESTMENT_ACCOUNT,
  STRUCTURED_PRODUCTS_ACCOUNT,
  BONDS_ACCOUNT,
} from 'srcAlias/client/enums/productDescriptionCode';
import {
  CREATED,
  NOT_CREATED,
} from 'srcAlias/client/enums/accountCreationStatus';

const getAccountNumberPanelLabel = (productType) => {
  for (const product of productMap) {
    if (productType === product.productType) {
      return product.labelText;
    }
  }
  return {};
};

const getCalloutWarningText = (productType) => {
  for (const product of productMap) {
    if (productType === product.productType) {
      return product.calloutText;
    }
  }
  return {};
};

const filterAccountDetails = (investmentAccountDetails, selectedProduct) => {
  return investmentAccountDetails.map((item) => {
    if (
      selectedProduct.productType !== STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY &&
      item.productCode !== STRUCTURED_PRODUCTS_ACCOUNT
    ) {
      //UT,BOND, SEC
      let result = {};
      if (item.openAccountStatus === CREATED) {
        productMap.map((product) => {
          if (item.productCode === product.productCode) {
            result = {
              ...item,
              showAccountNumberPanel: true,
              showInformationPanel: false,
              accountNumberPanelLabel: product.labelText,
              calloutWarningText: product.calloutText,
              productType: product.productType,
            };
          }
        });
      }
      return result;
    } else if (
      //select BOND, open bond
      selectedProduct.productType !== STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY &&
      item.productCode === BONDS_ACCOUNT
    ) {
      return {
        ...item,
        showAccountNumberPanel: true,
        showInformationPanel: false,
        accountNumberPanelLabel: getAccountNumberPanelLabel(
          BONDS_ACCOUNT_CATEGORY
        ),
        calloutWarningText: getCalloutWarningText(BONDS_ACCOUNT_CATEGORY),
        productType: BONDS_ACCOUNT_CATEGORY,
      };
    } else if (
      selectedProduct.productType === STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY
    ) {
      const isAccountCreated = item.openAccountStatus === CREATED;

      let result = {
        ...item,
        showAccountNumberPanel: isAccountCreated ? true : false,
        showInformationPanel: isAccountCreated ? false : true,
      };

      if (item.productCode === STRUCTURED_PRODUCTS_ACCOUNT) {
        result = {
          ...result,
          accountNumberPanelLabel: getAccountNumberPanelLabel(
            STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY
          ),
          calloutWarningText: getCalloutWarningText(
            STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY
          ),
          productType: STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY,
        };
        return result;
      } else if (item.productCode === EQUITY_INVESTMENT_ACCOUNT) {
        result = {
          ...result,
          accountNumberPanelLabel: getAccountNumberPanelLabel(
            EQUITY_INVESTMENT_ACCOUNT_CATEGORY
          ),
          calloutWarningText: getCalloutWarningText(
            EQUITY_INVESTMENT_ACCOUNT_CATEGORY
          ),
          productType: EQUITY_INVESTMENT_ACCOUNT_CATEGORY,
        };
        return result;
      }
      return result;
    }
    return undefined;
  });
};
//selectedProduct:{productCode:'UT_HBSP',productType:'UNIT_TRUST'}
export const getTransformedAccountDetails = (
  investmentAccountDetails = [],
  selectedProduct = {}
) => {
  if (selectedProduct.productType === STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY) {
    investmentAccountDetails = investmentAccountDetails.filter(
      (item) => item.productCode !== BONDS_ACCOUNT
    );
    const invstAcctTypeList = [];
    investmentAccountDetails.forEach((item) => {
      invstAcctTypeList.push(item.productCode);
    });
    if (!invstAcctTypeList.includes(STRUCTURED_PRODUCTS_ACCOUNT)) {
      investmentAccountDetails.push({
        productCode: STRUCTURED_PRODUCTS_ACCOUNT,
        openAccountStatus: NOT_CREATED,
      });
    }

    if (!invstAcctTypeList.includes(EQUITY_INVESTMENT_ACCOUNT)) {
      investmentAccountDetails.push({
        productCode: EQUITY_INVESTMENT_ACCOUNT,
        openAccountStatus: NOT_CREATED,
      });
    }
  }

  const filteredAcc = filterAccountDetails(
    investmentAccountDetails,
    selectedProduct
  );

  //sorting in descending order based on
  filteredAcc.sort((a, b) => {
    if (a.productType > b.productType) {
      return -1;
    }
    if (a.productType < b.productType) {
      return 1;
    }
    return 0;
  });

  return filteredAcc;
};
